document.addEventListener('DOMContentLoaded', () => {
  const root = document.querySelector('[data-pb-customizer]');
  if (!root) return;

  const textOpt = root.querySelector('[data-pb-textopt]');
  const yearWrap = root.querySelector('[data-pb-year]');
  const initialsWrap = root.querySelector('[data-pb-initials]');
  const preview = root.querySelector('[data-pb-preview]');
  const inputs = root.querySelectorAll('select, input');

  const vis = () => {
    const v = textOpt.value;
    yearWrap.classList.toggle('pb-hidden', v !== 'Est. Year');
    initialsWrap.classList.toggle('pb-hidden', v !== 'Initials');
  };

  const upd = () => {
    const bearCountRaw = root.querySelector('select[name="properties[Bear Count]"]').value;
    const bearLabel = root.querySelector('select[name="properties[Bear Count]"] option:checked').textContent.trim();
    const style = root.querySelector('select[name="properties[Style]"]').value;
    const v = textOpt.value;

    let text = 'No text';
    if (v === 'Est. Year') {
      const year = root.querySelector('input[name="properties[Year]"]').value.trim();
      text = year ? `Est. ${year}` : 'Est. (year)';
    } else if (v === 'Initials') {
      const ini = root.querySelector('input[name="properties[Initials]"]').value.trim();
      text = ini ? ini : 'Initials';
    } else if (v !== 'None') {
      text = v;
    }

    preview.textContent = `${style} • ${bearLabel} • ${text}`;
  };

  vis(); upd();
  inputs.forEach(i => i.addEventListener('input', () => { vis(); upd(); }));
});
// Cart quantity buttons (+ / -)
document.addEventListener('click', (e) => {
  const btn = e.target.closest('[data-qty]');
  if (!btn) return;

  const wrap = btn.closest('.qty');
  const input = wrap?.querySelector('.qty-input');
  if (!input) return;

  const delta = parseInt(btn.getAttribute('data-qty'), 10) || 0;
  const current = parseInt(input.value || '0', 10) || 0;
  const next = Math.max(0, current + delta);

  input.value = String(next);
});

